import { ArchiveIcon } from '@heroicons/react/outline';

export const EmptyState = ({ message }) => (
  <tbody>
    <tr>
      <td colSpan="100%" className="text-center py-8">
        <div className="flex flex-col items-center justify-center text-white/50">
          <ArchiveIcon className="h-10 w-10 mb-2 text-white/30" />
          <span className="text-sm">{message}</span>
        </div>
      </td>
    </tr>
  </tbody>
);
